import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const LANGS: { code: string; label: string }[] = [
  { code: 'sk', label: 'Slovenčina' },
  { code: 'en', label: 'English' },
  { code: 'cs', label: 'Čeština' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pl', label: 'Polski' },
  { code: 'hu', label: 'Magyar' },
  { code: 'uk', label: 'Українська' },
]

export default function LangSwitcher() {
  const { i18n } = useTranslation()
  const current = i18n.language
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const select = (lang: string) => {
    i18n.changeLanguage(lang)
    localStorage.setItem('lang', lang)
    setOpen(false)
  }

  // Zatvor pri kliku mimo
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const currentLabel = LANGS.find(l => l.code === current)?.code.toUpperCase() ?? 'SK'

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {/* Trigger tlačidlo */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 5,
          padding: '5px 10px', borderRadius: 8,
          border: '1px solid #e0e0e0',
          backgroundColor: open ? '#f4f4f4' : '#fff',
          color: '#555', fontSize: 13, fontWeight: 600,
          cursor: 'pointer', userSelect: 'none',
        }}
      >
        {/* Globe SVG */}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
        {currentLabel}
        {/* Šípka */}
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
          style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: 'absolute', right: 0, top: 'calc(100% + 6px)',
          backgroundColor: '#fff', borderRadius: 12,
          border: '1px solid #e8e8e8',
          boxShadow: '0 8px 24px rgba(0,0,0,0.10)',
          overflow: 'hidden', zIndex: 100, minWidth: 150,
        }}>
          {LANGS.map(lang => (
            <button
              key={lang.code}
              onClick={() => select(lang.code)}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                width: '100%', padding: '10px 14px',
                border: 'none', backgroundColor: 'transparent',
                fontSize: 14, cursor: 'pointer', textAlign: 'left',
                color: current === lang.code ? '#1a1a1a' : '#555',
                fontWeight: current === lang.code ? 600 : 400,
                background: current === lang.code ? '#f4f4f4' : 'transparent',
              } as React.CSSProperties}
            >
              {lang.label}
              {current === lang.code && (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="#2D7A3A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
